import { ReactComponent as PillowIcon } from './icons_pillow_.svg';
import { ReactComponent as FlowerIcon } from './icons_flower_.svg';
import { ReactComponent as BaseballIcon } from './icons_baseball_.svg';
import { ReactComponent as DefaultIcon } from './DefaultIcon.svg';
import { ReactComponent as BasketballIcon } from './icons_basketball_.svg';
import { ReactComponent as TennisIcon } from './icons_tennis_.svg';
import { ReactComponent as CubeIcon } from './icons_cube_.svg';
import { FunctionComponent, SVGProps } from 'react';

type SVGComponent = FunctionComponent<SVGProps<SVGSVGElement>>;

export const ProjectionIcons: Record<string, SVGComponent> = {
  EQUIRECTANGULAR: DefaultIcon,  // This should come first to ensure it's the default square
  PILLOW: PillowIcon,
  FLOWER: FlowerIcon,
  BASEBALL: BaseballIcon,
  CUBE: CubeIcon,     // Updated to use CubeIcon
  DOMES: DefaultIcon,
  LAMBERT: DefaultIcon,
  MERCATOR: DefaultIcon,
  BASKETBALL: BasketballIcon,
  TENNIS: TennisIcon, // Updated to use TennisIcon
  SOCCER: DefaultIcon
};